import { render } from "./CometChatCreateGroup.vue?vue&type=template&id=2a78fb6f&scoped=true"
import script from "./CometChatCreateGroup.vue?vue&type=script&lang=js"
export * from "./CometChatCreateGroup.vue?vue&type=script&lang=js"

import "./CometChatCreateGroup.vue?vue&type=style&index=0&id=2a78fb6f&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a78fb6f"]])

export default __exports__